





















































import { computed, defineComponent, ref } from "@vue/composition-api";
import { isVideoFile } from "@/lib/fileHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { StoryFeed } from "@/types";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "StoryItemMedia",
  components: { BaseSpinner },
  props: {
    feed: { type: Object as () => StoryFeed, required: true },
    isMuted: { type: Boolean, required: true },
    hasAccess: { type: Boolean, required: true },
  },
  setup(props, { emit }) {
    const player = ref<HTMLVideoElement>();
    const loadingStory = ref(false);
    const isPlayableVideo = computed(
      () =>
        props.hasAccess &&
        isVideoFile(props.feed.files[0]) &&
        ["NEW", "CONVERTING"].indexOf(props.feed.files[0].processingStatus) === -1
    );
    const isUnpublished = computed(() => props.feed.publishTime === null);
    const videoSrc = computed(() => MediaFilesController.getVideoUrl(props.feed.files[0].urlPart));
    const imageSrc = computed(
      () =>
        (isVideoFile(props.feed.files[0])
          ? MediaFilesController.getVideoThumbnail(props.feed.files[0].urlPart, "1080p")
          : MediaFilesController.getImageThumbnail(props.feed.files[0].urlPart, "1080p")) +
        "?timestamp=" +
        Date.now()
    );
    const storyOverlaySrc = computed(() => {
      loadingStory.value = false;
      return (!!props.feed.overlay && MediaFilesController.getFileUrl(props.feed.overlay.urlPart)) || "";
    });

    const onPlaying = () => {
      loadingStory.value = true;
      emit("canPlay");
    };

    const handleLoadBackground = () => {
      isUnpublished.value && emit("canPlay");
    };

    return {
      isPlayableVideo,
      imageSrc,
      videoSrc,
      loadingStory,
      storyOverlaySrc,
      player,
      isUnpublished,
      onPlaying,
      handleLoadBackground,
    };
  },
});
